export default {"src":"/_next/static/media/social-facebook.c915f991.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};